module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiExtIt.aaa0821.woff";